import { useDispatch, useSelector } from "react-redux";
import { store } from '../redux/store';
import * as loginActions from '../redux/actions/loginActions';
import { useEffect } from "react";

const usePermissions = () => {
    const dispatch = useDispatch();

    const role = useSelector(
        state => state.authReducer?.userAttributes?.userTenant?.role
    );

    const permissions = role?.permissions || [];

    useEffect(() => {
        if (!role) {
            store.dispatch(loginActions.authLogoutRequestAction())
        }
    }, [role, dispatch]);

    const hasPermission = (permission) => {
        return permissions.includes(permission);
    };

    return {
        permissions,
        hasPermission,
    };
};

export default usePermissions;